import * as React from 'react';
import {
  ClockArrowUpIcon,
  ClockArrowDownIcon,
  PackageCheckIcon,
  TruckIcon,
} from 'lucide-react';
import type { IndicatorStatusCode } from 'contracts/tracking-v2/invoice-indicators';
import { MAJOR_STATUS_DESCRIPTION_MAP } from 'constants/tracking-v2/invoice-indicators';
import { getMajorStatusCode } from 'pages/tracking-v2/utils/invoice-status-code-utils';
import { cn } from 'lib/utils';

type Props = React.ComponentProps<'div'> & {
  status: IndicatorStatusCode
}

export const IndicatorStatusIconAndLabel = ({ status, className, ...props }: Props) => {
  const majorStatusCode = getMajorStatusCode(status);
  const majorTitle = MAJOR_STATUS_DESCRIPTION_MAP[majorStatusCode];

  const Icon = React.useMemo(() => {
    switch (majorStatusCode) {
      case 'preparingForTransit':
        return ClockArrowUpIcon;
      case 'inTransit':
        return TruckIcon;
      case 'preparingForDelivery':
        return ClockArrowDownIcon;
      case 'delivered':
        return PackageCheckIcon;
    }
  }, [majorStatusCode]);

  return (
    <div
      {...props}
      className={cn(
      'flex items-center justify-center p-2 rounded-md gap-2 text-slate-50',
      majorStatusCode === 'preparingForTransit' && 'bg-sky-500',
      majorStatusCode === 'inTransit' && 'bg-yellow-500',
      status === 'inTransitOverDeadline' && 'bg-orange-500',
      majorStatusCode === 'preparingForDelivery' && 'bg-indigo-500',
      majorStatusCode === 'delivered' && 'bg-green-500',
      className,
    )}>
      <Icon className={'w-4 h-4'} />
      <span>{majorTitle}</span>
    </div>
  );
};